export default __webpack_public_path__ + "static/media/VisbyCF-DemiBold.217d8b6a.otf";